import appboy from 'appboy-web-sdk'
import recaptchaService from '@/js/RecaptchaService'
import userStore from '@/store/modules/user.store'
import store from '@/store'

class AuthenticationService {
  constructor() {
    this.fetchProfile = () => store.dispatch('user/verifyProfile')
    this.login = (parameters) => store.dispatch('authentication/signIn', parameters)
    this.storeSignUp = (parameters) => store.dispatch('authentication/signUp', parameters)
  }

  async signIn({ signInParameters, authenticationError }) {
    const action = signInParameters.authenticationPlatform
    signInParameters.recaptchaToken = await recaptchaService.getToken(`login_${action.toLowerCase()}`)

    try {
      await this.login(signInParameters)
    } catch (err) {
      if (authenticationError) {
        throw authenticationError
      }

      throw err
    }

    await this.fetchProfile()
    appboy.changeUser(userStore.state.accountId)
    appboy.openSession()
  }

  async signUp(authParameters) {
    authParameters.recaptchaToken = await recaptchaService.getToken('login')
    await this.storeSignUp(authParameters)
    await this.signIn({ signInParameters: authParameters })
  }
}

export default new AuthenticationService()
